module.exports = __webpack_public_path__ + "static/img/bubbles1.3c57343.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bubbles1.png
// module id = jxMj
// module chunks = 1